<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div
            class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
            id="kt_header_container"
          >
            <!--begin::Page title-->
            <div
              class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
            >
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Danh sách thông báo
                <small class="text-muted fs-6 fw-bold ms-1 pt-1"
                  >Số lượng {{ $numberFormat(items.metaData?.total) }}</small
                >
              </h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div
                class="btn btn-icon btn-active-icon-primary"
                id="kt_aside_toggle"
              >
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                      fill="black"
                    />
                    <path
                      opacity="0.3"
                      d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div
          class="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Row-->
            <div class="row g-5 g-lg-10">
              <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                  <!--begin::Card title-->
                  <div class="card-title">
                    <!--begin::Search-->
                    <div
                      class="d-flex align-items-center position-relative my-1"
                    >
                      <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
                      <span class="svg-icon svg-icon-1 position-absolute ms-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            opacity="0.5"
                            x="17.0365"
                            y="15.1223"
                            width="8.15546"
                            height="2"
                            rx="1"
                            transform="rotate(45 17.0365 15.1223)"
                            fill="black"
                          ></rect>
                          <path
                            d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                      <input
                        type="text"
                        data-kt-ecommerce-product-filter="search"
                        class="form-control form-control-solid w-250px ps-14"
                        placeholder="Search Product"
                      />
                    </div>
                    <!--end::Search-->
                  </div>
                  <!--end::Card title-->
                  <!--begin::Card toolbar-->
                  <div
                    class="card-toolbar flex-row-fluid justify-content-end gap-5"
                  >
                    <div class="w-100 mw-150px">
                      <!--begin::Select2-->
                      <select
                        class="form-select form-select-solid select2-hidden-accessible"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Status"
                        data-kt-ecommerce-product-filter="status"
                        data-select2-id="select2-data-7-7t3z"
                        tabindex="-1"
                        aria-hidden="true"
                      >
                        <option data-select2-id="select2-data-9-y8qf"></option>
                        <option value="all">Tất cả</option>
                        <option value="inactive">Chờ duyệt</option>
                        <option value="published">Hoàn thành</option>
                        <option value="scheduled">Từ chối</option></select
                      ><span
                        class="select2 select2-container select2-container--bootstrap5"
                        dir="ltr"
                        data-select2-id="select2-data-8-iagj"
                        style="width: 100%"
                        ><span class="selection"
                          ><span
                            class="select2-selection select2-selection--single form-select form-select-solid"
                            role="combobox"
                            aria-haspopup="true"
                            aria-expanded="false"
                            tabindex="0"
                            aria-disabled="false"
                            aria-labelledby="select2-69zs-container"
                            aria-controls="select2-69zs-container"
                            ><span
                              class="select2-selection__rendered"
                              id="select2-69zs-container"
                              role="textbox"
                              aria-readonly="true"
                              title="Status"
                              ><span class="select2-selection__placeholder"
                                >Status</span
                              ></span
                            ><span
                              class="select2-selection__arrow"
                              role="presentation"
                              ><b role="presentation"></b></span></span></span
                        ><span
                          class="dropdown-wrapper"
                          aria-hidden="true"
                        ></span
                      ></span>
                      <!--end::Select2-->
                    </div>
                    <!--begin::Add product-->
                    <!--                  <a href="javascript:void(0)" class="btn btn-primary">Thêm mới</a>-->
                    <b-button variant="primary" @click="modalShow = true">
                      Thêm mới
                    </b-button>
                    <b-modal
                        id="modal-create-request"
                        ref="createRequestModal"
                        v-model="modalShow"
                        hide-footer
                        title="Tạo Notification"
                        size="lg"
                    >
                      <b-tabs v-model="activeTab">
                        <!-- TAB USER -->
                        <b-tab title="Nhóm">
                          <div class="form-group mb-3 mt-3">
                            <label for="scope">Scope</label>
                            <select v-model="notificationBody.scope" id="scope" class="form-control" required>
                              <option disabled value="">-- Chọn scope --</option>
                              <option value="USER">USER</option>
                              <option value="AUTHOR">AUTHOR</option>
                              <option value="GLOBAL">GLOBAL</option>
                              <option value="MOD">MOD</option>
                            </select>
                          </div>

                          <!-- Title -->
                          <div class="form-group mb-3">
                            <label for="title">Tiêu đề</label>
                            <input
                                type="text"
                                id="title"
                                v-model="notificationBody.title"
                                class="form-control"
                                placeholder="Nhập tiêu đề"
                                required
                            />
                          </div>

                          <!-- Content -->
                          <div class="form-group mb-3">
                            <label for="content">Nội dung</label>
                            <textarea
                                id="content"
                                v-model="notificationBody.content"
                                class="form-control"
                                placeholder="Nhập nội dung"
                                required
                            ></textarea>
                          </div>

                          <!-- Type -->
                          <div class="form-group mb-3">
                            <label for="type">Loại Notification</label>
                            <select v-model="notificationBody.type" id="type" class="form-control" required>
                              <option disabled value="">-- Chọn loại --</option>
                              <option value="SYSTEM">SYSTEM</option>
                              <option value="LINK">LINK</option>
                            </select>
                          </div>

                          <!-- LinkData -->
                          <div v-if="notificationBody.type === 'LINK'">
                            <div class="form-group mb-3">
                              <label for="appLink">Link App</label>
                              <input
                                  type="url"
                                  id="appLink"
                                  v-model="notificationBody.linkData.app"
                                  class="form-control"
                                  placeholder="motapp://home"
                              />
                            </div>

                            <div class="form-group mb-3">
                              <label for="webLink">Link Web</label>
                              <input
                                  type="url"
                                  id="webLink"
                                  v-model="notificationBody.linkData.web"
                                  class="form-control"
                                  placeholder="https://example.com"
                              />
                            </div>
                          </div>

                          <!-- Submit -->
                          <div class="text-right">
                            <button type="submit"  :disabled="isSubmitting" class="btn btn-primary" @click="submitForm('PUBLIC')">Gửi</button>
                          </div>
                        </b-tab>

                        <!-- TAB AUTHOR -->
                        <b-tab title="Đối tượng">
                          <div class="form-group mb-3 mt-3">
                            <label>Tiêu đề</label>
                            <input v-model="notificationBody.title" type="text" class="form-control"/>
                          </div>
                          <div class="form-group mb-3">
                            <label>Nội dung</label>
                            <textarea v-model="notificationBody.content" class="form-control"></textarea>
                          </div>
                          <div class="form-group mb-3">
                            <label>User IDs (cách nhau bằng dấu phẩy)</label>
                            <textarea
                                v-model="userIdsText"
                                class="form-control"
                                placeholder="vd: 1,2,3,10"
                            ></textarea>
                          </div>
                          <div class="form-group mb-3">
                            <label>Author IDs (cách nhau bằng dấu phẩy)</label>
                            <textarea
                                v-model="authorIdsText"
                                class="form-control"
                                placeholder="vd: 1,2,3,10"
                            ></textarea>
                          </div>
                          <button class="btn btn-primary" :disabled="isSubmitting" @click="submitForm('GROUP')">Gửi</button>
                        </b-tab>

                        <!-- TAB GLOBAL/MOD -->
                        <b-tab title="FCM">
                          <div class="form-group mb-3 mt-3">
                            <label>Tiêu đề</label>
                            <input v-model="notificationBody.title" type="text" class="form-control"/>
                          </div>

                          <div class="form-group mb-3">
                            <label>Nội dung</label>
                            <textarea v-model="notificationBody.content" class="form-control"></textarea>
                          </div>

                          <div class="form-group mb-3">
                            <label>User IDs (cách nhau bằng dấu phẩy)</label>
                            <textarea
                                v-model="userIdsText"
                                class="form-control"
                                placeholder="vd: 1,2,3,10"
                            ></textarea>
                          </div>
                          <div class="form-group mb-3">
                            <label>Author IDs (cách nhau bằng dấu phẩy)</label>
                            <textarea
                                v-model="authorIdsText"
                                class="form-control"
                                placeholder="vd: 1,2,3,10"
                            ></textarea>
                          </div>

                          <button class="btn btn-primary" :disabled="isSubmitting" @click="submitForm('FCM')">Gửi</button>
                        </b-tab>
                      </b-tabs>
                    </b-modal>
                    <!--end::Add product-->
                  </div>
                  <!--end::Card toolbar-->
                </div>
                <!--begin::Card body-->
                <div class="card-body pt-0">
                  <!--begin::Table-->
                  <div
                    id="kt_ecommerce_category_table_wrapper"
                    class="dataTables_wrapper dt-bootstrap4 no-footer"
                  >
                    <div class="table-responsive">
                      <table
                        class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                        id="kt_ecommerce_category_table"
                      >
                        <!--begin::Table head-->
                        <thead>
                          <!--begin::Table row-->
                          <tr
                            class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
                          >
                            <th
                              class="w-10px pe-2 sorting_disabled"
                              rowspan="1"
                              colspan="1"
                              aria-label="
												"
                            >
                              <div
                                class="form-check form-check-sm form-check-custom form-check-solid me-3"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  data-kt-check="true"
                                  data-kt-check-target="#kt_ecommerce_category_table .form-check-input"
                                  value="1"
                                />
                              </div>
                            </th>
                            <th
                              class="text-start sorting"
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                            >
                              Nội dung
                            </th>
                            <th
                              class="sorting text-center"
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                            >
                              Phạm vi
                            </th>
                            <th
                              class="sorting text-center"
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                            >
                              Số người đọc
                            </th>
                            <th
                              class="sorting text-center"
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                            >
                              Tỉ lệ
                            </th>
                            <th
                              class="sorting text-center"
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                            >
                              Trạng thái
                            </th>
                            <th
                              class="text-center sorting"
                              tabindex="0"
                              aria-controls="kt_ecommerce_category_table"
                              rowspan="1"
                              colspan="1"
                              aria-label="Category Type: activate to sort column ascending"
                            >
                              Thời gian
                            </th>
                          </tr>
                          <!--end::Table row-->
                        </thead>
                        <!--end::Table head-->
                        <!--begin::Table body-->
                        <tbody class="fw-bold text-gray-600">
                          <tr
                            class="even"
                            v-for="(item, index) in this.items.data"
                            :key="index"
                          >
                            <!--begin::Checkbox-->
                            <td>
                              <div
                                class="form-check form-check-sm form-check-custom form-check-solid"
                              >
                                {{ item.id }}
                              </div>
                            </td>
                            <td style="width: 30%" v-html="item.content"></td>
                            <td class="text-center">
                              {{ item.scope }}
                            </td>
                            <td class="text-center">
                              {{ $numberFormat(item.countRead) }} /
                              {{ $numberFormat(item.count) }}
                            </td>
                            <td class="text-center">
                              {{
                                ((item.countRead * 100) / item.count).toFixed(2)
                              }}
                              %
                            </td>
                            <td class="text-center">
                              <span
                                v-if="item.status"
                                class="badge badge-success"
                                >Hoàn thành</span
                              >
                              <span v-else class="badge badge-warning"
                                >Chờ</span
                              >
                            </td>
                            <td class="text-center">
                              {{ $formatDateTime2(item.createdAt) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"
                      >
                        <div
                          class="dataTables_length"
                          id="kt_ecommerce_category_table_length"
                        >
                          <label
                            ><select
                              name="kt_ecommerce_category_table_length"
                              aria-controls="kt_ecommerce_category_table"
                              class="form-select form-select-sm form-select-solid"
                            >
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select></label
                          >
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
                      >
                        <div
                          class="dataTables_paginate paging_simple_numbers"
                          id="kt_ecommerce_category_table_paginate"
                        >
                          <ul class="pagination">
                            <li
                              class="paginate_button page-item previous disabled"
                              id="kt_ecommerce_category_table_previous"
                            >
                              <a
                                href="#"
                                aria-controls="kt_ecommerce_category_table"
                                data-dt-idx="0"
                                tabindex="0"
                                class="page-link"
                                ><i class="previous"></i
                              ></a>
                            </li>
                            <li class="paginate_button page-item active">
                              <a
                                href="#"
                                aria-controls="kt_ecommerce_category_table"
                                data-dt-idx="1"
                                tabindex="0"
                                class="page-link"
                                >1</a
                              >
                            </li>
                            <li class="paginate_button page-item">
                              <a
                                href="#"
                                aria-controls="kt_ecommerce_category_table"
                                data-dt-idx="2"
                                tabindex="0"
                                class="page-link"
                                >2</a
                              >
                            </li>
                            <li
                              class="paginate_button page-item next"
                              id="kt_ecommerce_category_table_next"
                            >
                              <a
                                href="#"
                                aria-controls="kt_ecommerce_category_table"
                                data-dt-idx="3"
                                tabindex="0"
                                class="page-link"
                                ><i class="next"></i
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end::Table-->
                </div>
                <!--end::Card body-->
              </div>
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Page-->
  </div>
</template>
<script>
import requestUtil from "@/utils/request-util";

export default {
  name: "NotificationList",
  computed: {},
  data() {
    return {
      items: {
        data: [],
        metaData: {},
      },
      modalShow: false,
      isSubmitting: false,
      dataForm: {},
      userIdsText: '',
      authorIdsText: '',
      notificationBody: {
        linkData: {
          web: '',
          app: '',
        }
      },
      isLoading: false,
      loading: {
        page: false,
        user: false,
      },
    };
  },
  mounted() {
    this.fetchItems();
  },
  created() {},
  methods: {
    async submitForm(type) {
      this.isSubmitting = true;
      try {
        this.notificationBody.userIds = this.userIdsText
            .split(',')
            .map(id => id.trim())
            .filter(Boolean)
            .map(Number)

        this.notificationBody.authorIds = this.authorIdsText
            .split(',')
            .map(id => id.trim())
            .filter(Boolean)
            .map(Number)

        let response

        if (type === 'FCM') {
          response = await requestUtil.post(
              "/admin/notification/fcm",
              this.notificationBody
          )
        }

        if (type === 'GROUP') {
          response = await requestUtil.post(
              "/admin/notification/group",
              this.notificationBody
          )
        }

        if (type === 'PUBLIC') {
          response = await requestUtil.post(
              "/admin/notification",
              this.notificationBody
          )
        }

        if (response?.status === 200) {
          this.$notify({
            title: 'Thành công',
            type: 'success',
          })

          // ✅ Đóng modal
          this.modalShow = false

          // ✅ Reset form
          this.resetForm()

          // ✅ Reload danh sách
          await this.fetchItems()
        }
      } catch (e) {
        this.$notify({
          title: 'Lỗi',
          text: e?.response?.data?.message || 'Có lỗi xảy ra',
          type: 'error',
        })
      }
      this.isSubmitting = false;
    },
    resetForm() {
      this.userIdsText = ''
      this.authorIdsText = ''
      this.activeTab = 0

      this.notificationBody = {
        scope: '',
        title: '',
        content: '',
        type: '',
        userIds: [],
        authorIds: [],
        linkData: {
          web: '',
          app: '',
        }
      }
    },
    async fetchItems() {
      const response = await requestUtil.get(
        "/admin/notification?sort=createdAt,desc"
      );
      if (response.status === 200) {
        this.items = response.data;
      }
    },
  },
};
</script>
<style></style>
